module.exports = __webpack_public_path__ + "img/vyshak-pic.37000169.jpg";